import React, { useEffect, useMemo, useRef, useState } from 'react';
import api from '../../services/apiClient.ts';
import { toast } from 'react-toastify';
import { RefreshCw, Calendar, PlusCircle, X, ChevronDown, Search } from 'lucide-react'; // NEW

// ——— Helpers ———
const fmtNum = (n) => Number(n || 0).toLocaleString();
const todayStr = () => new Date().toISOString().slice(0,10); // YYYY-MM-DD
const pick = (obj, keys) => keys.reduce((o,k)=> (obj[k]!==undefined && (o[k]=obj[k]), o), {});
const API_BASE = "/v1";
const formatWithCommas = (val) => {
  if (val === '' || val === null || val === undefined) return '';
  const num = Number(String(val).replace(/,/g, ''));
  if (Number.isNaN(num)) return '';
  return num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};
const parseFormattedNumber = (str) => {
  if (str === '' || str === null || str === undefined) return '';
  const cleaned = String(str).replace(/,/g, '').trim();
  if (cleaned === '') return '';
  const num = Number(cleaned);
  return Number.isNaN(num) ? '' : num;
};
const formatDateTime = (v) => {
  if (!v) return '';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

export default function InstallmentsMovements() {
  // فلاتر
  const [df, setDf] = useState(todayStr());
  const [dt, setDt] = useState(todayStr());
  const [scope, setScope] = useState('active'); // active | all
  const [groupId, setGroupId] = useState('');
  const [travelerId, setTravelerId] = useState('');
  const [installmentID, setInstallmentsID] = useState('');
  const [groupName, setGroupName] = useState('');     // بحث نصّي اختياري
  const [travelerName, setTravelerName] = useState(''); // بحث نصّي اختياري

  // بيانات الكومبو
  const [groups, setGroups] = useState([]);
  const [travelers, setTravelers] = useState([]);

  // جدول الحركات
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  // ترقيم
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);

  // ترتيب
  const [sort, setSort] = useState('created_at');
  const [dir, setDir] = useState('desc');

  const tenant = useMemo(() => localStorage.getItem('tenant') || 'default-tenant-1', []);
  const branch = useMemo(() => localStorage.getItem('branch_id') || '1', []);
  const selectedGroupName = useMemo(() => groups.find((g) => String(g.id) === String(groupId))?.name || '', [groups, groupId]);
  const selectedTravelerName = useMemo(() => travelers.find((t) => String(t.id) === String(travelerId))?.name || '', [travelers, travelerId]);
  const tableTotalAmount = useMemo(() => rows.reduce((sum, r) => sum + Number(r?.amount || 0), 0), [rows]);


  // تثبيت الهيدرز لكل طلب
  useEffect(() => {
    const id = api.interceptors.request.use((config) => {
      const token = localStorage.getItem('auth_token');
      if (token) config.headers.Authorization = `Bearer ${token}`;
      config.headers['X-Tenant'] = tenant;
      config.headers['X-Branch'] = branch;
      return config;
    });
    return () => api.interceptors.request.eject(id);
  }, [tenant, branch]);

  // جلب الكومبوات
  const fetchCombos = async () => {
    try {
      const params = { scope: 'all' };
      const resp = await api.get('/v1/installmentsQuerycombos', { params });
      setGroups(resp?.data?.groups || []);
      setTravelers(resp?.data?.travelers || []);
    } catch (e) {
      console.error(e);
    }
  };
  
  // 🔧 helper: حوّل datetime-local إلى "YYYY-MM-DD HH:mm:ss"
  const toSqlDateTime = (v) => {
    if (!v) return null; // v مثل "2025-11-09T14:05"
    return v.replace('T', ' ') + ':00';
  };

  const toDatetimeLocal = (dateString) => {
    if (!dateString) return '';

    const d = new Date(dateString);
    if (isNaN(d)) return '';

    const pad = (n) => n.toString().padStart(2, '0');

    const yyyy = d.getFullYear();
    const mm   = pad(d.getMonth() + 1);
    const dd   = pad(d.getDate());
    const hh   = pad(d.getHours());
    const min  = pad(d.getMinutes());

    return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
  }; 

    // NEW: حالة المودال + حقول الإدخال
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [amount, setAmount] = useState('');
  const [traveler_name, settraveler_name] = useState('');
  const [notes, setNotes] = useState('');
  const [dtSave , setDtSave] = useState(''); // datetime-local
  const [saving, setSaving] = useState(false);    

  // جلب الحركات
  const fetchMovements = async () => {
    setLoading(true); setErr('');
    try {
      const params = {
        df, dt, sort, dir, per_page: perPage, page,
        ...pick({ group_id: groupId || undefined, traveler_id: travelerId || undefined }, ['group_id','traveler_id'])
      };
      // بحث نصّي اختياري
      if (groupName.trim()) params.group_name = groupName.trim();
      if (travelerName.trim()) params.traveler_name = travelerName.trim();

      const resp = await api.get('/v1/installmentsQuery', { params });
      // استجابة اللارافيل: وضعنا كل الـ paginator داخل data
      const payload = resp?.data?.data;
      const items   = payload?.data || []; // الصفوف
      setRows(items);
      setPage(payload?.current_page || 1);
      setPerPage(payload?.per_page || 20);
      setLastPage(payload?.last_page || 1);
      setTotal(payload?.total || items.length);
    } catch (e) {
      setErr(e?.response?.data?.message || e.message || 'Network error');
      setRows([]);
      setLastPage(1); setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  // أول تحميل: كومبو + بيانات اليوم
  useEffect(() => { fetchCombos(); fetchMovements(); /* eslint-disable-next-line */ }, []);
  // إعادة تحميل الكومبو عند تغيير النطاق/التواريخ
  useEffect(() => { fetchCombos(); /* eslint-disable-next-line */ }, [scope, df, dt]);
  // إعادة تحميل الجدول عند تغيير الصفحة/الفرز/الحجم
  useEffect(() => { fetchMovements(); /* eslint-disable-next-line */ }, [page, perPage, sort, dir]);

  const applyFilters = () => { setPage(1); fetchMovements(); };
  const resetFilters = () => {
    setGroupId(''); setTravelerId('');
    setGroupName(''); setTravelerName('');
    setDf(todayStr()); setDt(todayStr());
    setScope('active');
    setPage(1); setPerPage(20); setSort('created_at'); setDir('desc');
    fetchCombos();
    fetchMovements();
  };

  const toggleOrder = (col) => {
    if (sort === col) setDir(dir === 'asc' ? 'desc' : 'asc');
    else { setSort(col); setDir('asc'); }
  };

  

    // NEW: افتح المودال
  const openInstallmentModal = async (row) => {
    try {
      const resp1 = await api.get(`/v1/installmentsQuery/by-entry/${row.id}`, {
        params: { scope }, // إذا محتاج تبعث سكوب
      });

      setSelectedRow(row);  
      const inst = resp1?.data?.data?.installment;

      settraveler_name(inst?.traveler_name ?? '');
      setAmount(inst?.amount ?? 0);
      setNotes(inst?.notes ?? '');
      setDtSave(toDatetimeLocal(inst?.created_at ?? inst?.updated_at ?? null));

      setModalOpen(true);
    } catch (e) {
      console.error(e);
    } 
  };

  async function remove(id){
    if (!window.confirm("حذف هذا القسط؟")) return;
    try{
      await api.delete(`${API_BASE}/installments/${id}`);
      toast.success("تم الحذف");
      fetchMovements();
    }catch(e){
      console.error(e);
      toast.error(e?.response?.data?.message || "فشل الحذف");
    }
  }  

    // NEW: حفظ القسط
  const saveInstallment = async () => {
    if (!selectedRow) return;

    const id       = selectedRow.id;
    const tenant   = localStorage.getItem('tenant')    || 'default-tenant-1';
    const branchId = localStorage.getItem('branch_id') || '1';

    // Basic validation
    if (!amount || Number(amount) <= 0) {
      alert('أدخل مبلغ صحيح.');
      return;
    }

    if (!dtSave) {
      alert('اختر تاريخ ووقت.');
      return;
    }

    // تجهيز الداتا التي تريد تغييرها فقط
    const payload = {
      amount: Number(amount),
      notes: notes || null,
      updated_at: toSqlDateTime(dtSave),  // <-- مهم
    };

    setSaving(true);

    try {
      await api.put(`/v1/installments/${id}`, payload, {
        headers: {
          'X-Tenant': tenant,
          'X-Branch': branchId,
          'Accept': 'application/json',
        }
      });

      setModalOpen(false);
      await fetchMovements();
      toast.success('تم الحفظ ✨');
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data?.message || 'خطأ أثناء الحفظ');
    } finally {
      setSaving(false);
    }
  };
  



  return (
    <div className="w-full mx-auto py-8 px-4 sm:px-6 lg:px-8">
      <div className="mb-6 rounded-2xl bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-lg">
        <div className="px-6 py-5 flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-extrabold">حركات الأقساط</h1>
            <p className="text-blue-100 text-sm mt-1">تقرير لحركات الاقساط الخاصة بالمتعتمرين داخل النظام</p>
          </div>
          <RefreshCw className={`w-6 h-6 ${loading ? 'animate-spin' : ''}`} />
        </div>
      </div>

      {/* فلاتر */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-5 mb-6 border border-gray-100 dark:border-gray-700">
        <div className="grid grid-cols-1 md:grid-cols-6 gap-4">
          {/* نطاق البيانات */}
          <div className="md:col-span-1">
            <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">النطاق</label>
            <select
              value={scope}
              onChange={(e)=>setScope(e.target.value)}
              className="w-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg px-3 py-2.5 text-gray-900 dark:text-gray-100"
            >
              <option value="active">نشط (خلال المدة)</option>
              <option value="all">الكل</option>
            </select>
          </div>

          {/* تاريخ من/إلى */}
          <div>
            <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">من تاريخ</label>
            <div className="relative">
              <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input type="date" value={df} onChange={(e)=>setDf(e.target.value)} className="w-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg pl-10 pr-3 py-2.5 text-gray-900 dark:text-gray-100" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">إلى تاريخ</label>
            <div className="relative">
              <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input type="date" value={dt} onChange={(e)=>setDt(e.target.value)} className="w-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg pl-10 pr-3 py-2.5 text-gray-900 dark:text-gray-100" />
            </div>
          </div>

          {/* كومبو المجموعة */}
          <div>
            <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">المجموعة</label>
            <SearchableSelect
              value={groupId}
              displayValue={selectedGroupName}
              onSelect={(id)=>setGroupId(id)}
              options={groups}
              placeholder="الكل"
              searchPlaceholder="بحث عن مجموعة..."
              clearLabel="الكل"
              getOptionValue={(opt)=>String(opt.id)}
              getOptionLabel={(opt)=>opt.name}
            />
          </div>

          {/* كومبو المسافر */}
          <div>
            <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">المسافر</label>
            <SearchableSelect
              value={travelerId}
              displayValue={selectedTravelerName}
              onSelect={(id)=>setTravelerId(id)}
              options={travelers}
              placeholder="الكل"
              searchPlaceholder="بحث عن مسافر..."
              clearLabel="الكل"
              getOptionValue={(opt)=>String(opt.id)}
              getOptionLabel={(opt)=>opt.name}
            />
          </div>

          {/* بحث نصّي اختياري */}
          <div className="md:col-span-2">
            <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">بحث بالاسم (مجموعة)</label>
            <input
              type="text"
              value={groupName}
              onChange={(e)=>setGroupName(e.target.value)}
              className="w-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg px-3 py-2.5 text-gray-900 dark:text-gray-100"
              placeholder="جزئي أو كامل"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">بحث بالاسم (مسافر)</label>
            <input
              type="text"
              value={travelerName}
              onChange={(e)=>setTravelerName(e.target.value)}
              className="w-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg px-3 py-2.5 text-gray-900 dark:text-gray-100"
              placeholder="جزئي أو كامل"
            />
          </div>

          {/* أزرار */}
          <div className="md:col-span-2 flex items-end gap-2">
            <button onClick={applyFilters} className="px-4 py-2.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-medium">
              تطبيق الفلاتر
            </button>
            <button onClick={resetFilters} className="px-4 py-2.5 rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-100 font-medium">
              إعادة ضبط
            </button>
          </div>
        </div>
      </div>

      {/* أخطاء */}
      {err && (
        <div className="mb-4 text-red-600">{err}</div>
      )}

      {/* جدول */}
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-lg border border-gray-100 dark:border-gray-700 overflow-hidden">
        <div className="app-table-wrap">
        <table className="app-table min-w-full">
          <thead className="bg-gray-50 dark:bg-gray-700">
            <tr>
              <Th label="الرمز" col="id" sort={sort} dir={dir} onSort={toggleOrder} align="center" />
              <Th label="المجموعة" col="group_name" onSort={toggleOrder} sort={sort} dir={dir} noSort align="center" />
              <Th label="المسافر" col="traveler_name" onSort={toggleOrder} sort={sort} dir={dir} noSort align="center" />
              <Th label="المبلغ" col="amount" sort={sort} dir={dir} onSort={toggleOrder} align="center" />
              <Th label="ملاحظات" col="notes" noSort align="center" />
              <Th label="تاريخ الحركة" col="created_at" sort={sort} dir={dir} onSort={toggleOrder} align="center" />
              <Th label="الاجرائات" align="center" noSort />              
            </tr>
          </thead>
          <tbody className="divide-y">
            {loading ? (
              <tr><td colSpan={7} className="p-4 text-center text-gray-500 dark:text-gray-400">جاري الجلب...</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={7} className="p-4 text-center text-gray-500 dark:text-gray-400">لا توجد بيانات</td></tr>
            ) : (
              rows.map(r => (
                <tr key={r.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/40 transition-colors">
                  <td className="p-3 text-sm whitespace-nowrap text-center text-gray-900 dark:text-gray-100">{r.id}</td>
                  <td className="p-3 text-sm whitespace-nowrap text-center text-gray-900 dark:text-gray-100">{r.group_name}</td>
                  <td className="p-3 text-sm whitespace-nowrap text-center text-gray-900 dark:text-gray-100">{r.traveler_name}</td>
                  <td className="p-3 text-sm text-center font-semibold whitespace-nowrap text-emerald-700 dark:text-emerald-400">{fmtNum(r.amount)}</td>
                  <td className="p-3 text-sm max-w-[180px] truncate text-center text-gray-700 dark:text-gray-300" title={r.notes || ''}>{r.notes || ''}</td>
                  <td className="p-3 text-sm whitespace-nowrap text-center text-gray-700 dark:text-gray-300">
                    {formatDateTime(r.created_at)}
                  </td>
                  <td className="p-3 text-sm whitespace-nowrap text-center">
                    <div className="flex gap-3 justify-center">
                      <button onClick={()=>openInstallmentModal(r)} className="text-indigo-600 hover:text-indigo-800">تعديل</button>
                      <button onClick={()=>remove(r.id)} className="text-red-600 hover:text-red-800">حذف</button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
          <tfoot className="bg-gray-50 dark:bg-gray-900">
            <tr>
              <td className="p-3 text-sm font-bold text-gray-700 dark:text-gray-200">الإجمالي</td>
              <td className="p-3" />
              <td className="p-3" />
              <td className="p-3 text-sm text-right font-extrabold text-emerald-700 dark:text-emerald-400">{fmtNum(tableTotalAmount)}</td>
              <td className="p-3" />
              <td className="p-3" />
              <td className="p-3" />
            </tr>
          </tfoot>
        </table>
        </div>
      </div>

      {/* ترقيم */}
      <div className="mt-4 flex items-center justify-between">
        <div className="text-sm text-gray-600">
          إجمالي: {fmtNum(total)} | صفحة {page} من {lastPage}
        </div>
        <div className="flex items-center gap-2">
          <button
            className="px-3 py-1 rounded border"
            onClick={()=> setPage((p)=> Math.max(1, p-1))}
            disabled={page <= 1 || loading}
          >
            السابق
          </button>
          <button
            className="px-3 py-1 rounded border"
            onClick={()=> setPage((p)=> Math.min(lastPage, p+1))}
            disabled={page >= lastPage || loading}
          >
            التالي
          </button>
          <select
            className="px-2 py-1 border rounded"
            value={perPage}
            onChange={(e)=> { setPerPage(Number(e.target.value)); setPage(1); }}
          >
            {[10,20,50,100].map(n => <option key={n} value={n}>{n}/صفحة</option>)}
          </select>
        </div>
      </div>

      {/* NEW: المودال */}
      {modalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
          <div className="w-full max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-2xl">
            <div className="flex items-center justify-between px-4 py-3 border-b dark:border-gray-700">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">استلام قسط</h3>
              <button onClick={() => setModalOpen(false)} className="p-1 rounded hover:bg-gray-100 dark:hover:bg-gray-700">
                <X className="w-5 h-5 text-gray-600 dark:text-gray-300" />
              </button>
            </div>
            {/* الاسم */}
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                الاسم
              </label>
              <input
                value={traveler_name}
                disabled
                onChange={(e) => settraveler_name(e.target.value)}
                className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-right"
              />
            </div>
            
            <div className="px-4 py-4 space-y-4">
              {/* تاريخ ووقت */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  التاريخ والوقت
                </label>
                <input
                  type="datetime-local"
                  value={dtSave}
                  onChange={(e) => setDtSave(e.target.value)}
                  className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                />
              </div>

              {/* مبلغ */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  المبلغ
                </label>
                <input
                  type="text"
                  inputMode="numeric"
                  value={formatWithCommas(amount)}
                  onChange={(e) => {
                    const parsed = parseFormattedNumber(e.target.value);
                    setAmount(parsed === '' ? '' : parsed);
                  }}
                  className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 focus:border-primary-500 text-right"
                  placeholder="0"
                />
              </div>

              {/* ملاحظات */}
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  ملاحظات
                </label>
                <textarea
                  rows={3}
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  className="w-full px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                  placeholder="مثال: الدفعة الأولى"
                />
              </div>
            </div>

            <div className="flex items-center justify-end gap-2 px-4 py-3 border-t dark:border-gray-700">
              <button
                onClick={() => setModalOpen(false)}
                className="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-100"
              >
                إلغاء
              </button>
              <button
                onClick={saveInstallment}
                disabled={saving}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-semibold"
              >
                <PlusCircle className="w-4 h-4" />
                {saving ? 'جاري الحفظ...' : 'حفظ القسط'}
              </button>
            </div>
          </div>
        </div>
      )}      






    </div>
  );
}

function SearchableSelect({
  value,
  displayValue,
  onSelect,
  options,
  placeholder,
  searchPlaceholder,
  clearLabel,
  getOptionValue,
  getOptionLabel,
}) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const rootRef = useRef(null);

  const filteredOptions = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return options;
    return options.filter((opt) => String(getOptionLabel(opt) || '').toLowerCase().includes(q));
  }, [options, query, getOptionLabel]);

  useEffect(() => {
    const closeOnOutside = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', closeOnOutside);
    return () => document.removeEventListener('mousedown', closeOnOutside);
  }, []);

  return (
    <div className="relative" ref={rootRef}>
      <button
        type="button"
        onClick={() => setOpen((s) => !s)}
        className="w-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg px-3 py-2.5 text-right text-gray-900 dark:text-gray-100 flex items-center justify-between"
      >
        <span className="truncate">{displayValue || placeholder}</span>
        <ChevronDown className={`w-4 h-4 text-gray-500 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute z-[80] mt-1 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-xl shadow-xl overflow-hidden">
          <div className="p-2 border-b border-gray-200 dark:border-gray-700">
            <div className="relative">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder={searchPlaceholder}
                className="w-full border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 rounded-lg pl-9 pr-3 py-2 text-sm text-gray-900 dark:text-gray-100"
              />
            </div>
          </div>

          <div className="max-h-56 overflow-y-auto">
            <button
              type="button"
              onClick={() => {
                onSelect('');
                setOpen(false);
              }}
              className={`w-full px-3 py-2 text-right text-sm hover:bg-blue-50 dark:hover:bg-gray-700 ${!value ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300' : 'text-gray-800 dark:text-gray-200'}`}
            >
              {clearLabel}
            </button>

            {filteredOptions.map((opt) => {
              const optValue = String(getOptionValue(opt));
              const isSelected = String(value) === optValue;
              return (
                <button
                  key={optValue}
                  type="button"
                  onClick={() => {
                    onSelect(optValue);
                    setOpen(false);
                  }}
                  className={`w-full px-3 py-2 text-right text-sm hover:bg-blue-50 dark:hover:bg-gray-700 ${isSelected ? 'bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300' : 'text-gray-800 dark:text-gray-200'}`}
                >
                  {getOptionLabel(opt)}
                </button>
              );
            })}

            {filteredOptions.length === 0 && (
              <div className="px-3 py-4 text-center text-sm text-gray-500 dark:text-gray-400">لا توجد نتائج</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// رأس عمود قابل للفرز
function Th({ label, col, sort, dir, onSort, align, noSort }) {
  const isActive = sort === col;
  const caret = isActive ? (dir === 'asc' ? '▲' : '▼') : '';
  const textAlign = align === 'right' ? 'text-right' : align === 'center' ? 'text-center' : 'text-right';
  const cls = 'px-3 py-2 text-xs font-semibold whitespace-nowrap ' + textAlign;

  return (
    <th className={cls}>
      {noSort ? (
        <span>{label}</span>
      ) : (
        <button
          onClick={()=>onSort(col)}
          className={`inline-flex items-center gap-1 ${align === 'center' ? 'justify-center w-full' : ''}`}
        >
          <span>{label}</span>
          <span className="opacity-60">{caret}</span>
        </button>
      )}
    </th>
  );
}
